import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';

import { ContentOverlayComponent } from './content-overlay.component';
import { AppDirectiveModule } from 'app/directive/shared-directive.module';

@NgModule({
  imports: [CommonModule, NgxMaskDirective, NgxMaskPipe, AppDirectiveModule],
  declarations: [ContentOverlayComponent],
  exports: [ContentOverlayComponent, AppDirectiveModule],
})
export class AppContentOverlayModule {}
